module.exports = __webpack_public_path__ + "img/video_1.0b067b86.png";